import { Cloudinary } from '@cloudinary/url-gen/index';

class Cloudinaries {
    
    static Use = ( { Name } ) => {
        const Cloud = new Cloudinary(
            {
                "cloud" : {
                    "cloudName" : 'dg5tctmkh',
                    "apiKey" : "483749943245215",
                    "apiSecret" : "_NBkstuqJAUCGb9jNUzQxrm38Ug"
                }
            }
        );
        const ASSET = Cloud.image(Name).format('auto').quality('auto').toURL();
        return ASSET;
    };

};

export default Cloudinaries;